var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemIconLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2073_4862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 15.625V17.5H23.5714V15.625C23.5714 13.8984 21.9732 12.5 20 12.5C18.0268 12.5 16.4286 13.8984 16.4286 15.625ZM13.5714 17.5V15.625C13.5714 12.5195 16.4509 10 20 10C23.5491 10 26.4286 12.5195 26.4286 15.625V17.5H27.1429C28.7188 17.5 30 18.6211 30 20V27.5C30 28.8789 28.7188 30 27.1429 30H12.8571C11.2813 30 10 28.8789 10 27.5V20C10 18.6211 11.2813 17.5 12.8571 17.5H13.5714Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2073_4862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemIconLocked);
export default __webpack_public_path__ + "static/media/gem-icon-locked.ce2190bc195925f566e5790bd4ebe3ad.svg";
export { ForwardRef as ReactComponent };